
import React from 'react';
import { Paper, Typography, TextField } from '@mui/material';
import { useTranslation } from '../../hooks/useTranslation';

const NotesSection = ({
  value = '',
  onChange,
  multilineStyle,
  rows = 4,
  label,
}) => {
  const { t } = useTranslation();
  const notesLabel = label ?? t('Common.Notes');

  return (
    <Paper
      elevation={0}
      sx={{
        p: 0.5,
        mb: 0.5,
        borderRadius: '4px',
        boxShadow: 'none',
        border: 'none',
        cursor: 'pointer',
        '&:hover': {
          backgroundColor: 'rgba(0, 0, 0, 0.02)',
        },
      }}
    >
      <Typography
        variant="subtitle1"
        fontWeight={600}
        sx={{ mb: 0.5, fontSize: '0.875rem' }}
      >
        {notesLabel}
      </Typography>

      <TextField
        label={notesLabel}
        value={value}
        onChange={onChange}
        fullWidth
        multiline
        rows={rows}
        margin="dense"
        size="small"
        sx={multilineStyle}
      />
    </Paper>
  );
};

export default NotesSection;
